import { useSelector } from 'react-redux';
import { forwardRef, Ref } from 'react';
import { Choices } from 'components/Filter/themes/BGH-RD3/types/choices';
import { Section } from 'components/Section';
import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { nbrOfHitsSelector, totalNbrOfHitsSelector } from 'components/Filter/selector';
import { getHeader } from 'views/ProductlistPage/selectors';
import { getShowingAmountCaption } from '../types';
import { Filter } from './filter';
import { Sort } from './sort';
import styles from './styles.scss';
import { NO_ELEMENT } from 'utils';

export const FilterMobile = forwardRef((_, ref: Ref<HTMLDivElement>) => {
  const isMobile = useSelector(isMobileSelector);
  const nbrOfHits = useSelector(nbrOfHitsSelector);
  const totalNbrOfHits = useSelector(totalNbrOfHitsSelector);
  const header = useSelector(getHeader);

  if (totalNbrOfHits <= 0) {
    return NO_ELEMENT;
  }

  const showingAmountCaption = getShowingAmountCaption(nbrOfHits);

  return (
    <div ref={ref} className={styles.filterMobile}>
      <Section className={styles.section}>
        <div className={styles.buttons}>
          {!isMobile && header && <h1 className={styles.title}>{header}</h1>}
          <div className={styles.nbrOfHits}>{showingAmountCaption}</div>
          <div>
            <Filter className={styles.button} />
            <Sort className={styles.button} />
          </div>
        </div>
        <Choices />
      </Section>
    </div>
  );
});
